module.exports = __webpack_public_path__ + "static/media/logo.ec90bb93.svg";